import { onTrainActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { TrainActivityCard } from "./TrainActivityCard";

interface Props {
  trainId: number
  config: server.dto.ActivityPanelConfig
}

export const TrainActivityPanel = (props: Props) => {

  return <ActivityPanel<server.dto.TrainActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.Train.ListActivity({ itemId: props.trainId, page, perPage })}
    renderActivity={(activity => <TrainActivityCard
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onTrainActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.trainId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}